import React from 'react';
import styled from 'styled-components';
import { FaSearch } from 'react-icons/fa';

const Title = styled.div`
  font-size: 26px;
  font-weight: 700;
  color: #222;
  padding-top: 12px;
  margin-bottom: 28px;
  text-align: left;
  padding-left: 24px;
`;

const SearchBox = styled.div`
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 10px;
  padding: 0 18px;
  margin: 0 24px 32px 24px;
  height: 56px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
`;

const SearchIcon = styled(FaSearch)`
  font-size: 20px;
  color: #888;
  margin-right: 12px;
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  font-size: 18px;
  flex: 1;
  background: transparent;
  color: #222;
  &::placeholder {
    color: #bbb;
    opacity: 1;
  }
`;

/**
 * BookSearchHeader
 * @param {string} title - 상단 타이틀
 * @param {string} placeholder - 검색창 placeholder
 * @param {string} value - 검색어 값
 * @param {function} onChange - 검색어 변경 핸들러
 * @param {function} onSearch - 엔터 또는 아이콘 클릭 시 검색
 */
const BookSearchHeader = ({
  title = '어떤 책을 찾으시나요?',
  placeholder = '책, 저자, 출판사를 검색해 보세요',
  value = '',
  onChange,
  onSearch,
  inputRef
}) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && onSearch) onSearch();
  };
  return (
    <>
      <Title>{title}</Title>
      <SearchBox>
        <SearchIcon onClick={onSearch} style={{ cursor: onSearch ? 'pointer' : 'default' }} />
        <SearchInput
          ref={inputRef}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onKeyDown={handleKeyDown}
        />
      </SearchBox>
    </>
  );
};

export default BookSearchHeader; 